import './App.css'
import { DataProvider, useDataContext } from './context/DataProvider'
import { AxiosClient } from './apis/configs/AxiosClient'
import { LoadingProvider } from './context/LoadingProvider'
import { CloseButtonProps, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Preloader } from './context/Preloader'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import Home from './pages/Home'
import SelfAssessment from './pages/SelfAssessment'
import Questions from './pages/Questions'
import End from './pages/End'
import Support from './pages/Support'
import DoneBefore from './pages/DoneBefore'
import QuizFlow from './pages/quiz/QuizFlow'
import SimulatorPage from './pages/quiz/SimulatorPage'

const CustomCloseButton = ({ closeToast }: CloseButtonProps) => {
  return (
    <>
      <button
        className="Toastify__close-button Toastify__close-button--light"
        type="button"
        aria-label="close"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5286 3.52864C11.7889 3.26834 12.2106 3.26845 12.471 3.52864C12.7113 3.76896 12.73 4.14699 12.5267 4.40852L12.471 4.47102L8.94171 7.99934L12.471 11.5286C12.7314 11.789 12.7314 12.2107 12.471 12.471C12.2307 12.7113 11.8526 12.73 11.5911 12.5267L11.5286 12.471L7.99932 8.94172L4.471 12.471C4.21065 12.7314 3.78897 12.7314 3.52862 12.471C3.28845 12.2307 3.26965 11.8526 3.47296 11.5911L3.52862 11.5286L7.05694 7.99934L3.52862 4.47102C3.26843 4.21066 3.26832 3.78893 3.52862 3.52864C3.76891 3.28835 4.14698 3.26972 4.4085 3.47297L4.471 3.52864L7.99932 7.05696L11.5286 3.52864Z"
            fill="black"
          />
        </svg>
      </button>
    </>
  )
}

const AppRoutes = () => {
  const { step } = useDataContext()
  return (
    <>
      {/* <Timer initialSeconds={assessment?.setup.timeLimit ?? 0} /> */}
      <Routes>
        <Route path="/support" element={<Support />} />
        <Route
          path="/*"
          element={
            <>
              {step === 0 && <Home />}
              {step === 1 && <SelfAssessment />}
              {step === 2 && <Questions />}
              {step === 3 && <End />}
              {step === 4 && <DoneBefore />}
            </>
          }
        />
      </Routes>
    </>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AxiosClient>
        <>
          <ToastContainer limit={99} closeButton={CustomCloseButton} />
          <Routes>
            {/* ── quiz engine simulator ── */}
            <Route path="/sim" element={<SimulatorPage />} />
            <Route path="/sim/:slug" element={<SimulatorPage />} />
            {/* ── self-service assessment quiz ── */}
            <Route path="/digital" element={<QuizFlow />} />
            <Route path="/digital/:slug" element={<QuizFlow />} />
            {/* ── v1 / v2 (existing) ── */}
            <Route
              path="/*"
              element={
                <DataProvider>
                  <LoadingProvider>
                    <Preloader>
                      <div className="App">
                        <AppRoutes />
                      </div>
                    </Preloader>
                  </LoadingProvider>
                </DataProvider>
              }
            />
          </Routes>
        </>
      </AxiosClient>
    </BrowserRouter>
  )
}

export default App
